import apiClient from './apiClient';

export const cloudService = {
  async getAzureSubscriptions() {
    try {
      const response = await apiClient.get('/cloud/azure/subscriptions', {
        timeout: 30000
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar subscriptions:', error);
      throw error;
    }
  },

  async getAzureCostData(subscriptionId: string, period: string) {
    try {
      const response = await apiClient.get('/cloud/azure/cost-data', {
        params: { subscriptionId, period },
        timeout: 60000
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar dados de custo:', error);
      throw error;
    }
  },

  async getAzureFinOpsData(subscriptionId: string) {
    try {
      const response = await apiClient.get('/cloud/azure/finops-data', {
        params: { subscriptionId },
        timeout: 60000
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar dados FinOps:', error);
      throw error;
    }
  },

  async getAzureFinOpsShell(subscriptionId: string) {
    try {
      const response = await apiClient.get('/cloud/azure/finops-shell', {
        params: { subscriptionId },
        timeout: 30000
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar shell FinOps Azure:', error);
      throw error;
    }
  },

  async getAzureFinOpsBlock(subscriptionId: string, block: string) {
    try {
      const response = await apiClient.get(`/cloud/azure/finops-block/${block}`, {
        params: { subscriptionId },
        timeout: 60000
      });
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar bloco Azure ${block}:`, error);
      throw error;
    }
  },

  async getDashboardData(provider: string, subscriptionId?: string, period?: string) {
    try {
      const response = await apiClient.get(`/cloud/${provider}/dashboard`, {
        params: { subscriptionId, period }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar dados do dashboard:', error);
      throw error;
    }
  },

  async getSubscriptions(provider: string) {
    try {
      const response = await apiClient.get(`/cloud/${provider}/subscriptions`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar subscriptions:', error);
      throw error;
    }
  }
};
